import {LegacyPeriodReportBoundary} from "./Layout/LegacyPeriodReportBoundary.jsx";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import PnoInTimeGraph from "./TablesAndGraphs/ByFilter/PnoInTimeGraph.jsx";
import OrdersInTimeGraph from "./TablesAndGraphs/ByFilter/OrdersInTimeGraph.jsx";
import React, {useContext, useEffect, useState} from "react";
import ClicksInTimeGraph from "./TablesAndGraphs/ByFilter/ClicksInTimeGraph.jsx";
import CpcInTimeGraph from "./TablesAndGraphs/ByFilter/CpcInTimeGraph.jsx";
import {FilterContext} from "../../../components/filters/DashboardFilterContextProvider.jsx";
import {ErpCalculationApi} from "../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../api/utilities/useAuthorityConfiguration.js";
import {useLegacyPeriodReportError} from "./Layout/LegacyPeriodReportBoundary.jsx";
import toast from "react-hot-toast";
import ReportingSnapshotStatus from "../../admin/ReportingSnapshotStatus.jsx";
import CampaignOrderBasis from "./TablesAndGraphs/ByFilter/CampaignOrderBasis.jsx";

function CampaignPerformanceContent({project}) {

    let {t} = useTranslation();
    let {et} = useLegacyPeriodReportError();
    let authorityConfiguration = useAuthorityConfiguration();
    let {since, until, centresAllowListed, domainsAllowListed} = useContext(FilterContext);
    const {customerWholesaleRequestFilter} = useContext(FilterContext);
    let sinceKey = since.format('YYYY-MM-DD');
    let untilKey = until.format('YYYY-MM-DD');
    let [data, setData] = useState(null);

    useEffect(() => {
        let active = true;
        setData(null);

        new ErpCalculationApi(authorityConfiguration)
            .reportingMarketingTrends({
                projectId: project.id,
                erpFilter: {
                    ...customerWholesaleRequestFilter,
                    since: sinceKey,
                    until: untilKey,
                    selectedCentreIds: centresAllowListed ?? [],
                    selectedDomainIds: domainsAllowListed ?? [],
                },
            })
            .then((nextData) => {
                if (active) {
                    setData(nextData);
                }
            })
            .catch((e) => {
                if (active) {
                    et(e).then((message) => { if (message) toast.error(message); });
                }
            });

        return () => {
            active = false;
        };
    }, [project.id, sinceKey, untilKey, centresAllowListed, domainsAllowListed, customerWholesaleRequestFilter]);

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-comparison')} showMarketingFilters={true} showModeSwitch={false}>
        <ReportingSnapshotStatus snapshots={data?.snapshot}/>
        <div className="col-span-12 mb-2"><CampaignOrderBasis isMarketing={true}/></div>
        <PnoInTimeGraph project={project} metricContext="marketing" fullWidth={true} showLegend={false} data={data?.pno ?? null} snapshot={data?.snapshot}/>
        <OrdersInTimeGraph project={project} metricContext="marketing" fullWidth={true} showLegend={false} data={data?.orders ?? null} snapshot={data?.snapshot}/>
        <ClicksInTimeGraph project={project} fullWidth={true} showLegend={false} data={data?.clicks ?? null} snapshot={data?.snapshot}/>
        <CpcInTimeGraph project={project} fullWidth={true} showLegend={false} data={data?.cpc ?? null} snapshot={data?.snapshot}/>
    </OrderDashboardLayout>;
}

export default function CampaignPerformance(props) {
    return <LegacyPeriodReportBoundary project={props.project}><CampaignPerformanceContent {...props}/></LegacyPeriodReportBoundary>;
}
